import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotifierService } from 'src/app/_services/notifier.service';

@Component({
  selector: 'app-view-monthly-tab',
  templateUrl: './view-monthly-tab.component.html',
  styleUrls: ['./view-monthly-tab.component.css']
})
export class ViewMonthlyTabComponent implements OnInit {

  @Output() hideModal = new EventEmitter<any>();
  @Input() monthlyCost :any=[];

  constructor(public notifier: NotifierService,) { }

  ngOnInit(): void {
    this.notifier.disableScroll();
  }
 
  
  no(){
    this.hideModal.emit({ status: 0 });
    
  }
  ngOnDestroy(): void {
    this.notifier.enableScroll();
}

}
